module.exports = __webpack_public_path__ + "static/media/app-store-logo.480b4c23.jpg";